import { produce } from "immer";
import * as Actions from "./layoutActions";
import storage from "@storage";

const initialState = {
  isWidgetsOpen: true,
  isMobileMenuExist: false,
  isMobileMenuOpen: false,
  isSidebarCollapsed: false,
  isSidebarFixed: false,
  columnView: storage.get("columnView") || "vertical",
  density: storage.get("density") || "standard",
  theme: document.body.getAttribute("data-theme") === "dark" ? "dark" : "light",
  isAddAccountOpen: false
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.OPEN_WIDGETS:
      draft.isWidgetsOpen = true;
      break;

    case Actions.CLOSE_WIDGETS:
      draft.isWidgetsOpen = false;
      break;

    case Actions.CREATE_MOBILE_MENU:
      draft.isMobileMenuExist = true;
      break;

    case Actions.REMOVE_MOBILE_MENU:
      draft.isMobileMenuExist = false;
      draft.isMobileMenuOpen = false;
      break;

    case Actions.OPEN_MOBILE_MENU:
      draft.isMobileMenuOpen = true;
      break;

    case Actions.CLOSE_MOBILE_MENU:
      draft.isMobileMenuOpen = false;
      break;

    case Actions.EXPAND_SIDEBAR:
      draft.isSidebarCollapsed = false;
      break;

    case Actions.COLLAPSE_SIDEBAR:
      draft.isSidebarCollapsed = true;
      break;

    case Actions.CHANGE_COLUMN_VIEW:
      draft.columnView = action.payload.columnView;
      break;

    case Actions.CHANGE_DENSITY:
      draft.density = action.payload.density;
      break;

    case Actions.SET_THEME:
      draft.theme = action.payload.theme;
      break;

    case Actions.SET_FIXED_SIDEBAR:
      draft.isSidebarFixed = action.payload;
      break;

    case Actions.TOGGLE_ADD_ACCOUNT:
      draft.isAddAccountOpen = !draft.isAddAccountOpen;
      break;

    case Actions.OPEN_ADD_ACCOUNT:
      draft.isAddAccountOpen = true;
      break;

    case Actions.CLOSE_ADD_ACCOUNT:
      draft.isAddAccountOpen = false;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
